<div [ngSwitch]="paymentMethod">
  <ng-template [ngSwitchCase]="'Agency Bill'">
    <div [innerHTML]="getDescription(paymentMethod)"></div>
    <button
      type="button"
      (click)="purchase('Agency Bill')"
      class="btn btn-primary btn-margin-top"
    >
      Purchase
    </button>
  </ng-template>

  <ng-template [ngSwitchCase]="'Paperless Premium Financing'">
    <div [innerHTML]="getDescription(paymentMethod)"></div>
    <button
      type="button"
      (click)="purchase('Paperless Premium Financing')"
      class="btn btn-primary btn-margin-top"
    >
      Continue
    </button>
  </ng-template>

  <ng-template [ngSwitchCase]="'Installment Bill'">
    <span *ngIf="installmentBillingAggrement; else installmentBill">
      <p class="text-danger">{{ installmentBillAgrMessage }}</p>
    </span>
    <ng-template #installmentBill>
      <div [innerHTML]="getDescription(paymentMethod)"></div>
      <button
        type="button"
        (click)="purchase('Installment Bill')"
        class="btn btn-primary"
      >
        Continue
      </button>
    </ng-template>
  </ng-template>
</div>
